export const timer = ( ) => {
  let id = null
  let callback
  const cancel = () => {
    if ( id !== null ) {
      clearTimeout(id)
    }
  }
  const runAndClear = () => {
    if ( id !== null ) {
      clearTimeout(id)
      id = null
      callback()
    }
  }
  const start = (newCallback, time) => {
    callback = newCallback
    id = setTimeout( ()=> {
      callback()
      id = null
    }, time)
  }
  return {
    cancel,
    runAndClear,
    start
  }
}
